import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminAccountEditPage = ({ clickChangeMenu }) => {
    const [roles, setRoles] = useState([]);
    const [formData, setFormData] = useState({
        username: '',
        password: '',
        confirmPassword: '',
        email: '',
        fullName: '',
        roleIds: []
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        AdminApi.getRoles().then(data => setRoles(data));
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleRoleChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, roleIds: value ? [parseInt(value)] : [] }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.username || !formData.password) {
            alert("Vui lòng nhập tên đăng nhập và mật khẩu");
            return;
        }
        if (formData.password !== formData.confirmPassword) {
            alert("Mật khẩu xác nhận không khớp");
            return;
        }

        setIsLoading(true);
        try {
            await AdminApi.createMember(formData);
            alert("Tạo tài khoản thành công");
            clickChangeMenu('taikhoan');
        } catch (err) {
            console.error("Error creating member:", err);
            alert("Lỗi khi tạo tài khoản");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Tạo Tài khoản</h3>

            <form onSubmit={handleSubmit} className="form-horizontal" style={{ marginTop: '30px' }}>
                <div className="control-group">
                    <label className="control-label" style={{ width: '200px' }}>Đăng nhập</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="text" name="username" value={formData.username} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Mật khẩu</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="password" name="password" value={formData.password} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Mật khẩu Xác nhận</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Nhóm thành viên</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <select
                            name="roleIds"
                            className="span6"
                            value={formData.roleIds[0] || ''}
                            onChange={handleRoleChange}
                        >
                            <option value="">-- Chọn nhóm --</option>
                            {roles.map(role => (
                                <option key={role.roleid} value={role.roleid}>{role.rolename}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-actions" style={{ backgroundColor: '#f9f9f9', borderTop: '1px solid #eee', padding: '15px 220px', marginTop: '30px', marginLeft: '-20px', marginRight: '-20px', borderRadius: '0 0 8px 8px' }}>
                    <button type="submit" className="btn btn-primary" style={{ backgroundColor: '#5cb85c', border: 'none', padding: '6px 20px' }} disabled={isLoading}>
                        {isLoading ? 'Đang xử lý...' : 'Tạo'}
                    </button>
                    <button type="button" className="btn" style={{ marginLeft: '10px', padding: '6px 20px' }} onClick={() => clickChangeMenu('taikhoan')}>Quay lại</button>
                </div>
            </form>
        </div>
    );
};

export default AdminAccountEditPage;
